import React, { useEffect, useState } from "react"
import fetch from "cross-fetch"
import SbEditable from "storyblok-react"

import Loader from "../loader"
import { CareerSearchTypes, CareerEventType, CareerFilterArgType, CareerJobListType } from "./partials/CareerSearchTypes"
import CareerSelectFilter from "./partials/CareerSelectFilter"
import SingleCareerJob from "./partials/SingleCareerJob"
import { CareerJobConverter } from "./helpers/CareerSearchJobConverter"
import CareerSearchFitler from "./partials/CareerSearchFilter"
import CareerSearchResults from "./partials/CareerSearchResults"

const CareerSearch = ({ blok }: CareerSearchTypes) => {

  const { job_type_filter_label, location_filter_label, title } = blok

  const [filterArg, setFilterArg] = useState<CareerFilterArgType>({
    filteredJobType: "",
    filteredLocation: "",
  })
  const [allJobs, setAllJobs] = useState([])
  const [locationDropdown, setLocationDropdown] = useState<string[]>([""])
  const [jobTypeDropdown, setJobTypeDropdown] = useState<string[]>([""])

  useEffect(() => {

    fetch(`${process.env.GATSBY_CAREERS_API}?maxjobs=1000&division=Hult%20International%20Business%20School`)
      .then((res) => {
        if (res.status >= 400) {
          throw new Error("Bad response from server")
        }
        return res.json()
      })
      .then(resData => {
        const uniqueLocations: string[] = []
        const uniqueJobTypes: string[] = []

        resData.forEach(({ locationName, categories }: CareerJobListType) => {
          const locationArr = locationName.split(",")
          const country = locationArr[locationArr.length - 1]

          if (!uniqueLocations.includes(country)) {
            uniqueLocations.push(country)
          }

          const unqiueCheck = (category: string) => {
            if (!uniqueJobTypes.includes(category) && category !== "") {
              uniqueJobTypes.push(category)
            }
          }

          const multiCheck = (input: string) => input.split(",").length > 1

          multiCheck(categories) ?
            categories.split(",").forEach((cat) => unqiueCheck(cat))
            :
            unqiueCheck(categories)
        });

        setAllJobs(resData)
        setLocationDropdown(uniqueLocations.sort())
        setJobTypeDropdown(uniqueJobTypes.sort())
      })
      .catch((err) => console.error(err))
  }, [])

  const filteredList = allJobs.filter((job: CareerJobListType) => {

    const { filteredJobType, filteredLocation } = filterArg

    if (!filteredJobType && !filteredLocation) return job

    if (job.categories.includes(filteredJobType) && !filteredLocation
      ||
      job.locationName.includes(filteredLocation) && !filteredJobType) {

      return job
    }

    return job.locationName.includes(filteredLocation) && job.categories.includes(filteredJobType)
  })

  const handleTypeFilter = (e: CareerEventType) => {
    setFilterArg({
      filteredJobType: e.target.value,
      filteredLocation: filterArg.filteredLocation
    })
  }

  const handleLocationFilter = (e: CareerEventType) => {
    setFilterArg({
      filteredJobType: filterArg.filteredJobType,
      filteredLocation: e.target.value,
    })
  }

  const jobTypeDropdownList = jobTypeDropdown.map((type) => (
    <option className="job_filter-type" key={type} value={type}>
      {CareerJobConverter[type]}
    </option>
  ))

  const locationDropdownList = locationDropdown.map((location) => (
    <option className="job_filter-location" key={location} value={location}>
      {location}
    </option>
  ))

  const RenderedJobs = () => {

    if (!filteredList.length) return <h1>No Jobs Found</h1>

    return <>{filteredList.map((job) => <SingleCareerJob job={job} job_path={blok.job_path} />)}</>
  }

  return (
    <SbEditable content={blok}>
      <div className="grid grid--gutters-sm grid--v-top">
        <CareerSearchFitler>
          <CareerSelectFilter
            labelStyle="selector__type"
            label={job_type_filter_label}
            onChange={handleTypeFilter}
            list={jobTypeDropdownList}
          />
          <CareerSelectFilter
            labelStyle="selector__locations"
            label={location_filter_label}
            onChange={handleLocationFilter}
            list={locationDropdownList}
          />
        </CareerSearchFitler>
        <CareerSearchResults title={title}>
          {allJobs.length !== 0 ? <RenderedJobs /> : <Loader />}
        </CareerSearchResults>
      </div>
    </SbEditable>
  )
}

export default CareerSearch

